import React, { useEffect, useMemo, useState } from "react";
import { parseMessageContent, normalizeUrl, ParsedMessagePart } from "../../services";
import styles from "./ReadMore.scss";

function ReadMore(props: any) {
  const { text, min } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncatable, setIsTruncatable] = useState(false);

  useEffect(() => {
    if (text.length > min) {
      setIsTruncatable(true);
    }
  }, [text, min]);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const parts = useMemo(() => parseMessageContent(text).parts, [text]);

  // Truncate across parts so a link cut in the middle still points to its full URL
  const getDisplayParts = (): Array<ParsedMessagePart & { href?: string }> => {
    if (!isTruncatable || isExpanded) {
      return parts;
    }

    const result: Array<ParsedMessagePart & { href?: string }> = [];
    let remaining = min;

    for (const part of parts) {
      if (remaining <= 0) {
        break;
      }
      result.push({
        ...part,
        content: part.content.substring(0, remaining),
        href: part.type === "link" ? part.content : undefined
      });
      remaining -= part.content.length;
    }

    return result;
  };

  const renderText = () =>
    getDisplayParts().map((part, index) => {
      if (part.type === "text") {
        return <React.Fragment key={index}>{part.content}</React.Fragment>;
      }

      return (
        <a
          key={index}
          href={normalizeUrl(part.href || part.content)}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className={styles.link}
        >
          {part.content}
        </a>
      );
    });

  const renderToggleBtn = () => {
    if (!isTruncatable) {
      return null;
    }

    return (
      <span>
        {!isExpanded && "..."}
        <span
          role="button"
          tabIndex={0}
          onClick={handleToggle}
          className={styles.readMoreBtn}
        >
          {isExpanded
            ? "Vidi manje"
            : "Pročitaj više"}
        </span>
      </span>
    );
  };

  return (
    <div className={styles.container}>
      {renderText()}
      {renderToggleBtn()}
    </div>
  );
}

ReadMore.defaultProps = {
  min: 250
};

export default ReadMore;



// WEBPACK FOOTER //
// ./src/components/ReadMore/index.tsx